import React from "react";

const Button = ({
  text,
  onClick,
  BtnType = "button",
  widthSize = "full", // "full" or number
  heightSize = 40,
  textColor = "#ff6943",
  bgColor,
  borderColor = "#ff6943",
  hoverTextColor = "#ffffff",
  hoverBgClass = "#ff6943", // hex or rgba
  classes = "",
  icon = null,
  iconPosition = "left", 
}) => {
  const widthStyle = widthSize === "full" ? "w-full" : "";

  return (
    <button
      type={BtnType}
      onClick={onClick}
      className={`
        group
        ${widthStyle} 
        relative cursor-pointer overflow-hidden font-semibold rounded-md border 
        flex items-center justify-center gap-2
        transition-all duration-300 text-center
        ${classes}
      `}
      style={{
        "--txt": textColor,
        "--hover-txt": hoverTextColor,
        "--hover-bg": hoverBgClass,
        "--bg-color": bgColor,
        backcolor: "var(--bg-color)",
        color: "var(--txt)",
        borderColor: borderColor,
        width: typeof widthSize === "number" ? `${widthSize}px` : undefined,
        height: `${heightSize}px`,
      }}
    >
      {/* HOVER BACKGROUND */}
      <span
        className="
          absolute inset-0 
          bg-[var(--hover-bg)]
          -translate-x-full 
          group-hover:translate-x-0
          transition-transform duration-300
        "
      ></span>

      {icon && iconPosition === "left" && (
        <span className="relative z-10 group-hover:text-[var(--hover-txt)] transition-colors">
          {icon}
        </span>
      )}

      <span className="relative z-10 group-hover:text-[var(--hover-txt)] transition-colors">
        {text}
      </span>

      {icon && iconPosition === "right" && (
        <span className="relative z-10 group-hover:text-[var(--hover-txt)] transition-colors">
          {icon}
        </span>
      )}
    </button>
  );
};

export default Button;
